import { AuthButton, AuthButtonVariant } from 'modules/auth/components'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import loginBg from 'shared/assets/backgrounds/login-bg.webp'
import { APP_ROUTES } from 'shared/constants/routes'

import { AuthPageTemplate } from '../../templates'
import styles from './PackageDetails.module.scss'
import { PackageDetailsCard } from './components'

export const PackageDetails = () => {
  const { t } = useTranslation('auth', { keyPrefix: 'package_details' })
  const navigate = useNavigate()

  const handleStartTrial = () => {
    navigate(APP_ROUTES.desktop.path)
  }
  return (
    <AuthPageTemplate
      showHeader={false}
      className={styles.packageDetails}
      backgroundImageUrl={loginBg}
    >
      <div className={styles.content}>
        <h1 className={styles.mobileTitle}>{t('title')}</h1>
        <PackageDetailsCard />
        <div className={styles.actionButtonsWrapper}>
          <h1 className={styles.title}>{t('title')}</h1>
          <div className={styles.buttonsWrapper}>
            <AuthButton
              label={t('buttons.start_trial')}
              variant={AuthButtonVariant.FILLED}
              fullWidth
              onClick={handleStartTrial}
            />
          </div>
        </div>
      </div>
    </AuthPageTemplate>
  )
}
